const datasetHu = {
	datasetTable: 'Dataset',
	name: 'Név',
	datasetEditForm: 'Dataset',
	basic: 'Alapadatok',
	table_name: 'Tábla neve',
	description: 'Leírás',
	fields: 'Mezők',
	role: 'Szabály',
	type: 'Típus',
	keyFields: 'Key fields',
	valueFields: 'Value fields',
	userGroup: 'User Group'
};

export default datasetHu;
